var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingCartSolid = function SvgShoppingCartSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3h1.146l2.763 17.501c.016.101.035.226.061.335.03.129.085.306.203.487a1.5 1.5 0 0 0 .637.544c.197.089.38.115.513.125.112.008.237.008.34.008H19a1 1 0 1 0 0-2H7.854l-.315-2h9.825c.445 0 .834 0 1.157-.024a3.032 3.032 0 0 0 1.026-.233 3 3 0 0 0 1.265-1.056c.208-.307.325-.633.412-.967.082-.314.152-.696.231-1.135l1.362-7.489c.025-.139.055-.299.068-.44.015-.16.022-.4-.073-.664a1.5 1.5 0 0 0-.66-.79 1.515 1.515 0 0 0-.639-.19C21.372 5 21.209 5 21.068 5H5.486l-.395-2.501a4.65 4.65 0 0 0-.061-.335 1.503 1.503 0 0 0-.203-.487 1.5 1.5 0 0 0-.637-.544 1.503 1.503 0 0 0-.513-.125A4.645 4.645 0 0 0 3.337 1H2a1 1 0 0 0 0 2Z",
    fill: "currentcolor"
  })));
};
export default SvgShoppingCartSolid;